import { PagedEntityListOfPayrollInvoice, PayrollInvoice, PayrollInvoiceStatus } from "@herbjoy/apex-api-models";
import { IHttpService } from "angular";

export class PayrollInvoiceService {
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject'
    }

    retrievePayrollInvoices(query?) {
        return this.$http<PayrollInvoice[]>({
            method: "GET",
            url: this.apexApiUrl + "payroll-invoices/",
            params: query,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    retrievePayrollInvoicesPage(pageIndex: number, query?) {
        return this.$http.get<PagedEntityListOfPayrollInvoice>(
            `${this.apexApiUrl}payroll-invoices/page/${pageIndex || 0}`,
            {
                params: query,
                headers: { Accept: "application/json" }
            })
            .then(function (response) {
                return response.data;
            });
    }

    retrieveNewPayrollInvoices() {
        return this.$http<PayrollInvoice[]>({
            method: "GET",
            url: this.apexApiUrl + "payroll-invoices/new",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        })
    }

    retrievePayrollInvoice(payrollID: number) {
        return this.$http<PayrollInvoice>({
            method: "GET",
            url: this.apexApiUrl + "payroll-invoices/" + payrollID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    createPayrollInvoice(payrollID: number, invoiceDate: Date | string) {
        const data = {
            payrollID: payrollID,
            invoiceDate: invoiceDate
        };
        return this.$http<PayrollInvoice>({
            method: "POST",
            url: this.apexApiUrl + "payroll-invoices",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            data: data
        }).then(function (response) {
            return response.data;
        });
    }

    updatePayrollInvoice(payrollID, payrollInvoice) {
        const invoiceDTO = {
            StatusID: payrollInvoice.StatusID,
            Adjustment: payrollInvoice.Adjustment,
            AdjustmentComments: payrollInvoice.AdjustmentComments,
            PaymentMethodID: payrollInvoice.PaymentMethodID,
            HJComments: payrollInvoice.HJComments,
            HubComments: payrollInvoice.HubComments,
            OwnerComments: payrollInvoice.OwnerComments,
            IsDismissed: payrollInvoice.IsDismissed
        };

        return this.$http<PayrollInvoice>({
            method: "PUT",
            url: this.apexApiUrl + "payroll-invoices/" + payrollID,
            data: invoiceDTO,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    retrievePayrollInvoiceStatuses() {
        return this.$http<PayrollInvoiceStatus>({
            method: "GET",
            url: this.apexApiUrl + "payroll-invoice-statuses/",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    retrievePaymentMethods() {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "payment-methods/",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }
}
